<template>
	
	<dl class="nebikiPriceInfo sort-item"
		v-if="(ptInitData.productInfo.NEBIKI_PRICE > 0 && ptInitData.productInfo.NEBIKI_PRICE != ptInitData.productInfo.PRICE) && !(ptInitData.siteKbn == '4' && !ptInitData.loginKbn && ptInitData.priceShowBtoB == 0) && ptInitData.priceShow != 1">
		<!--値引価格 -->
		<template v-if="(ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2') &&
			(ptInitData.productInfo.NEBIKI_PRICE > 0)">
			<dd v-if="ptInitData.productInfo.NEBIKI_FLG == 1">
				<span class="nebikiRate">
					{{ ptInitData.productInfo.NEBIKI_RATE }}%{{ $t('common.labels.nebikiRtRate') }}
				</span>
			</dd>
		</template>
	</dl>
</template>
<script>
export default {
	methods: {
	},
	name: "nebikiRtRate",
	props: {
		ptInitData: {
			type: Object,
			default: null,
		}
	}
}
</script>